import {
  Poll,
  PollAnswerItem,
  PollQuestion,
  PollSetupStage,
  getOptionValue,
  isOptionRequired,
} from './types'

const DEPARTMENT_TITLES: Record<string, string> = {
  has_sales: 'Базовые разделы',
  has_logistics: 'Логистика',
  has_claims: 'Рекламации',
  has_montage: 'Монтажи',
  has_measurers: 'Замеры',
}

export function buildClientSetupStages(poll: Poll, answers: PollAnswerItem[]): PollSetupStage[] {
  const stages: PollSetupStage[] = [{ key: 'brand', title: 'Сохраняем бренд', status: 'pending' }]
  const deptAnswer = answers.find(item => item.system_key === 'company_departments')?.answer
  const codes = new Set(Array.isArray(deptAnswer) ? deptAnswer.map(String) : [])
  codes.add('has_sales')
  const question = poll.questions.find(q => q.config?.system_key === 'company_departments')
  if (question) {
    for (const option of question.options) {
      if (isOptionRequired(option)) codes.add(getOptionValue(option))
    }
  }
  for (const code of codes) {
    stages.push({
      key: `dept:${code}`,
      title: DEPARTMENT_TITLES[code] || code,
      status: 'pending',
    })
  }
  stages.push({ key: 'requisites', title: 'Сохраняем реквизиты', status: 'pending' })
  return stages
}

export function requiredOptionValues(question: PollQuestion): string[] {
  return (question.options || []).filter(isOptionRequired).map(getOptionValue)
}
